import React from 'react';
import { 
  Paper, 
  Typography, 
  Box, 
  Grid, 
  Card, 
  CardContent,
  Divider 
} from '@mui/material';
import { UserInfo } from '../../UserInfo';
import { UserAvatar } from '../../UserAvatar';
import { useAuth } from '../../../contexts/AuthContext';
import { useUserData } from '../../../hooks/useUserData';
import styles from './Profile.module.css';

export const Profile: React.FC = () => {
  const { user } = useAuth();
  const { userData } = useUserData();

  // Prioriza dados do contexto, depois dados salvos
  const currentUser = user || userData;

  if (!currentUser) {
    return (
      <div className={styles.profileContainer}>
        <Paper className={styles.profilePaper}>
          <Typography variant="h5">
            Perfil do Usuário
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Nenhum usuário logado
          </Typography>
        </Paper>
      </div>
    );
  }

  return (
    <div className={styles.profileContainer}>
      <Paper className={styles.profilePaper}>
        <Typography variant="h4" className={styles.title}>
          Perfil do Usuário
        </Typography>
        
        <Divider className={styles.divider} />
        
        <Grid container spacing={3}>
          {/* Card de Informações Básicas */}
          <Grid >
            <Card className={styles.infoCard}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Informações Básicas
                </Typography>
                
                <UserInfo 
                  variant="detailed"
                  showProvider={true}
                  className={styles.userInfoDetailed}
                />
              </CardContent>
            </Card>
          </Grid>
          
          {/* Card de Avatar */}
          <Grid>
            <Card className={styles.avatarCard}>
              <CardContent className={styles.avatarContent}>
                <Typography variant="h6" gutterBottom>
                  Avatar
                </Typography>
                
                <Box className={styles.avatarDisplay}>
                  <UserAvatar size="xlarge" />
                  
                  <Box className={styles.avatarInfo}>
                    <Typography variant="body2" color="textSecondary">
                      {currentUser.picture ? 'Foto do Google' : 'Iniciais'}
                    </Typography>
                    
                    {currentUser.picture && (
                      <Typography 
                        variant="caption" 
                        color="textSecondary"
                        className={styles.avatarUrl}
                      >
                        {currentUser.picture}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          
          {/* Card de Dados Técnicos */}
          <Grid>
            <Card className={styles.technicalCard}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Dados Técnicos
                </Typography>
                
                <Grid container spacing={2}>
                  <Grid >
                    <Typography variant="body2" color="textSecondary">
                      ID do Usuário:
                    </Typography>
                    <Typography variant="body1">
                      {currentUser.id}
                    </Typography>
                  </Grid>
                  
                  <Grid>
                    <Typography variant="body2" color="textSecondary">
                      Provedor:
                    </Typography>
                    <Typography variant="body1">
                      {currentUser.provider || 'email'}
                    </Typography>
                  </Grid>
                  
                  {currentUser.given_name && (
                    <Grid>
                      <Typography variant="body2" color="textSecondary">
                        Primeiro Nome:
                      </Typography>
                      <Typography variant="body1">
                        {currentUser.given_name}
                      </Typography>
                    </Grid>
                  )}
                  
                  {currentUser.family_name && (
                    <Grid>
                      <Typography variant="body2" color="textSecondary">
                        Sobrenome:
                      </Typography>
                      <Typography variant="body1">
                        {currentUser.family_name}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};